import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { BookingReportTemplate } from '../booking-report-template';
import { PrimeToastService } from '../prime-toast.service';
import { PdfDocumentType } from '../pdf-document-type';
import { Language } from '../language';
import { PdfDocumentCategory } from '../pdf-document-category';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';
import { SelectItem } from 'primeng/api';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-pdf-template-edit',
  templateUrl: './pdf-template-edit.component.html',
  styleUrls: ['./pdf-template-edit.component.css']
})
export class PdfTemplateEditComponent implements OnInit {

  templateForm!: FormGroup;
  selectedTemplate!: BookingReportTemplate;
  advancedEditor = true;
  languages: Language[] = [];
  categories: PdfDocumentCategory[] = [];
  schoolDocument: PdfDocumentType = new PdfDocumentType(1, "school document");
  studentDocument: PdfDocumentType = new PdfDocumentType(2, "student document");


  @ViewChild("editor") editor: any;
  @ViewChild("textArea") textArea!: ElementRef;

  public Editor = Editor;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private toastService: PrimeToastService,
    public pdfService: PdfDocumentTemplateService,
    private pdfTemplateService: PdfDocumentTemplateService
  ) { }

  ngOnInit() {
    this.httpService.getLanguages().subscribe(res => {
      this.languages = res;
      this.httpService.getPdfDocumentCategories().subscribe(res => {
        this.categories = res;

        this.httpService.getPdfDocumentTemplateById(this.pdfService.selectedBookingPdfTemplate.id!).subscribe(temp => {
          this.selectedTemplate = temp;
          this.templateForm = this.builder.group({
            name: [this.selectedTemplate.name, Validators.required],
            body: [this.selectedTemplate.body, Validators.required],
            language: this.selectedTemplate.documentLanguage,
            category: this.selectedTemplate.pdfDocumentCategory,
            documentTypeId: this.selectedTemplate.documentType.id
          });
        });
      });
    });
  }

  backToTemplateList(){
    this.pdfTemplateService.activeItemId = PdfTemplateViewOption.BOOKING_RELATED;
  }

  editorConfig: any = {
    toolbarGroups: [
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
      { name: 'forms', groups: ['forms'] },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
      { name: 'links', groups: ['links'] },
      { name: 'insert', groups: ['insert'] },
      '/',
      { name: 'styles', groups: ['styles'] },
      { name: 'colors', groups: ['colors'] },
      { name: 'tools', groups: ['tools'] },
      { name: 'others', groups: ['others'] },
      { name: 'about', groups: ['about'] }
    ],
    removeButtons: "Save,Templates,Preview,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,TextField,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,RemoveFormat,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Unlink,Link,Maximize,ShowBlocks,About,Smiley,Subscript,Superscript,Print,NewPage,Blockquote,Flash,PageBreak,SpecialChar,HorizontalRule,BGColor",
    contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
    defaultLabel: "Arial",
    height: "450px",
    protectedSource: []
  };

  sendForm() {
    if (this.templateForm.invalid) {
      return;
    }

    this.updateSelectedTemplate();
    this.httpService.updatePdfTemplate(this.selectedTemplate).subscribe(() => {
      console.log("success");
      this.toastService.addSuccess("Success", "saved without problem");
    }, error => this.toastService.addError("Error", error.message));

  }

  updateSelectedTemplate() {
    this.selectedTemplate.body = this.templateForm.value.body.trim();
    this.selectedTemplate.name = this.templateForm.value.name.trim();
    this.selectedTemplate.documentType = this.templateForm.value.documentType;
    if(this.templateForm.value.documentTypeId === 1){
      this.selectedTemplate.documentType = this.schoolDocument;
    } else {
      this.selectedTemplate.documentType = this.studentDocument;
    }
    this.selectedTemplate.documentLanguage = this.templateForm.value.language;
    this.selectedTemplate.pdfDocumentCategory = this.templateForm.value.category;
  }

  activateAdvanced() {
    this.advancedEditor = this.advancedEditor ? false : true;
  }

  insertFieldValue(field: SelectItem) {
    if (this.advancedEditor) {
      this.insertStrToTextArea(field.value);
    } else {
      this.editor.instance.insertText(field.value);
    }
  }

  insertStrToTextArea(str: string) {
    if (this.textArea.nativeElement.selectionStart || this.textArea.nativeElement.selectionStaart == '0') {
      let startPos = this.textArea.nativeElement.selectionStart;
      let endPos = this.textArea.nativeElement.selectionEnd;
      this.textArea.nativeElement.value = this.textArea.nativeElement.value.substring(0, startPos) +
        str + this.textArea.nativeElement.value.substring(endPos, this.textArea.nativeElement.value.length);
    } else {
      this.textArea.nativeElement.value += str;
    }
  }
}
